import React from "react";
import "./Gallery.css";

function Gallery() {
  const galleryItems = [
    { type: "image", src: "/assets/images/gallery/img_1.webp" },
    { type: "image", src: "/assets/images/gallery/img_2.webp" },
    { type: "image", src: "/assets/images/gallery/img_3.webp" },
    { type: "image", src: "/assets/images/gallery/img_4.webp" },
    { type: "image", src: "/assets/images/gallery/img_5.webp" },
    { type: "image", src: "/assets/images/gallery/img_6.webp" },
    { type: "image", src: "/assets/images/gallery/img_7.webp" },
    { type: "image", src: "/assets/images/gallery/img_8.webp" },
    { type: "image", src: "/assets/images/gallery/img_9.webp" },
  ];

  return (
    <section className="Gallery">
      {/* TOP BANNER */}
      <div className="gallery_banner_top">
        <div className="gallery_banner_top_overlay">
          <h1 className="gallery_banner_title">Gallery </h1>
          <p className="gallery_banner_subtitle">
            A blend of comfort, luxury & nature
          </p>
        </div>
      </div>

      {/* GALLERY SECTION */}
      <div className="gallery_section">
        <div className="gallery_container">
          <h2 className="gallery_heading"> Gallery</h2>
          <div className="row">
            <div className="col-12">
              <video className="resort_vdo" controls muted playsInline>
                <source
                  src="/assets/images/gallery/jaltaaraa_vdo.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
          <div className="gallery_grid">
            {galleryItems.map((item, index) => (
              <div className="gallery_item" key={index}>
                <img src={item.src} alt={`gallery-${index}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Gallery;
